import React, { Fragment, useState } from "react";
import { Btn, ToolTip } from "../../../../AbstractElements";
import { Href } from "../../../../Constant";
import { CommonCustomStateButtonsProp } from "../../../../Type/CommonComponant";

const CommonRasiedCustomStateButtons = ({ data }: CommonCustomStateButtonsProp) => {
  const [buttonATooltip, setButtAtooltip] = useState(false);
  const buttonAToggle = () => setButtAtooltip(!buttonATooltip);

  return (
    <Fragment>
      <Btn as={data.as} tag={data.tag} href={Href} color={data.color} value={data.value} id={`Tooltip-${data.id}`} type={data.type} className={`btn-pill btn-air-${data.color}`}>
        {data.text}
      </Btn>
      <ToolTip target={`Tooltip-${data.id}`} isOpen={buttonATooltip} toggle={buttonAToggle}>
        {data.toolText}
      </ToolTip>
    </Fragment>
  );
};

export default CommonRasiedCustomStateButtons;
